import React from "react";
import { GREEN } from "./constants";

export const Footer = () => (
  <div style={{ position: "absolute", bottom: 0, left: 0, right: 0 }}>
    <div style={{
      height: 32,
      background: GREEN,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "0 32px",
    }}>
      <div style={{
        color: "white",
        fontWeight: 900,
        fontSize: 10,
        textTransform: "uppercase",
        letterSpacing: 2,
        whiteSpace: "nowrap",
        fontFamily: "'Arial Black', Arial, sans-serif",
      }}>
        Giving MLB hitters a measurable exit velocity boost.
      </div>
      <div style={{
        color: "rgba(0,0,0,0.55)",
        fontSize: 9,
        letterSpacing: 1,
        fontFamily: "Arial, sans-serif",
      }}>
        longballlabs.com
      </div>
    </div>
  </div>
);
